import React from 'react'
import PropTypes from 'prop-types';
import { injectStripe, CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements';
import SelectInput from '../../form/select';
import Input from '../../form/Input';
import Very from '../../../helpers/request_wrapper';

class Step1 extends React.Component {
  static propTypes = {
    stripe: PropTypes.object.isRequired,
  };

  state = {
    country: this.props.customer && this.props.customer.country ? this.props.customer.country.toString() : '',
    city: this.props.customer && this.props.customer.city ? this.props.customer.city : '',
    address: this.props.customer && this.props.customer.address ? this.props.customer.address : '',
    postal_code: this.props.customer && this.props.customer.postal_code ? this.props.customer.postal_code : '',
    name: this.props.customer && this.props.customer.name ? this.props.customer.name : '',

    saving: false,
    error: null
  };

  removeCustomer = () => {
    Very.delete(`/customers/${this.props.customer.id}`)
  };

  chargeCustomer = async (e) => {
    e.preventDefault();

    const { stripe, customer } = this.props;

    if (customer) { await this.removeCustomer() }

    this.setState({ error: null, saving: true });

    const res = await stripe.createToken();

    if (res.error) {
      this.setState({ error: res.error.message, saving: false });
      return;
    }

    let { city, address, country, postal_code } = this.state;

    Very.post('/customers', {
      token: res.token.id,
      email: this.state.email,
      name: this.state.name,
      address: { line1: address, city: city, country: country, postal_code: postal_code }
    }).then(res => {
      Very.post('/charges', { resource_id: this.props.mediaPlan.id, resource_type: 'MediaPlan' }).then(res => {
        window.location.replace(`/media_plans/${this.props.mediaPlan.id}`)
      })
    }, err => {
      this.setState({ error: err.data.errors, saving: false })
    });
  };

  render() {
    const { saving, error } = this.state;
    const { countries, customer } = this.props;
    const CountryOptions = countries.map(country => {
      return { label: country.country_data_or_code.name, value: country.country_data_or_code.name }
    });

    return (
      <React.Fragment>
        <form onSubmit={this.chargeCustomer}>
          <p className="center title mb-30">Checkout</p>

          <div className="mx-auto" style={{ maxWidth: '350px' }}>
            <div className="mb-20">
              <CardNumberElement />
            </div>

            <div className="flex mb-30 mxn-10">
              <div className="col-6 px-10">
                <CardExpiryElement />
              </div>

              <div className="col-6 px-10">
                <CardCVCElement />
              </div>
            </div>

            <p className="title center mb-30 ">Billing</p>

            <div className="mx-auto" style={{ maxWidth: '370px' }}>
              <div className="mb-20">
                <Input
                  label="Billing name"
                  required
                  value={customer && customer.name}
                  onChange={(name) => this.setState({ name })}
                />
              </div>

              <div className="mb-20">
                <Input
                  label="Street address"
                  value={customer && customer.address}
                  required
                  onChange={(address) => this.setState({ address })}
                />
              </div>

              <div className="flex mb-20 mxn-10">
                <div className="col-6 px-10">
                  <Input
                    value={customer && customer.postal_code}
                    label="ZIP / Postal code"
                    onChange={(postal_code) => this.setState({ postal_code })}
                  />
                </div>

                <div className="col-6 px-10">
                  <Input
                    required
                    label="City"
                    value={customer && customer.city}
                    onChange={(city) => this.setState({ city })}
                  />
                </div>
              </div>

              <div className="mb-30">
                <SelectInput
                  className="react-select"
                  name="countries"
                  value={this.state.country}
                  onChange={(country) => this.setState({ country: country.value })}
                  options={CountryOptions}
                  placeholder="Country"
                  required
                />
              </div>
            </div>

            {error && <p className="text-violet-red mb-20">{error}</p>}

            <div className="mb-10">
              {saving ?
                <p>Processing your card...</p>
                :
                <input
                  className="btn btn--primary col-12 mb-20"
                  type="submit"
                  value={`Pay - ${this.props.price/100}$`}
                />
              }
            </div>
          </div>
        </form>
      </React.Fragment>
    );
  }
}

export default injectStripe(Step1)
